import axios from "@/libs/api.request";
// 获取列表
export const getList = data => {
  return axios.request({
    url: "/cost/extract/index",
    method: "post",
    data
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/ClearanceCost",
    data,
    method: "post"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/ClearanceCost/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/ClearanceCost/${id}`,
    method: "DELETE"
  });
};

// 获取配置
export const getConfig = params => {
  return axios.request({
    url: "/finance/ClearanceCost/conf",
    method: "get",
    params
  });
};


export const cost_classify = params => {
  return axios.request({
    url: "/common/cost_classify",
    method: "get",
    params
  });
};

export const cost_expense_item = params => {
  return axios.request({
    url: "/common/cost_expense_item",
    method: "get",
    params
  });
};

export const createBill = data => {
  return axios.request({
    url: "/cost/extract/create_bill",
    data,
    method: "post"
  });
};

export const createDeliveryBill = data => {
  return axios.request({
    url: "/cost/extract/create_send_bill",
    data,
    method: "post"
  });
};

export const clearance_fee = data => {
  return axios.request({
    url: "/cost/summary/clearance_fee",
    data,
    method: "post"
  });
};

export const create_tag = data => {
  return axios.request({
    url: "/cost/extract/create_tag",
    data,
    method: "post"
  });
};

export const preview = data => {
  return axios.request({
    url: "/cost/extract/preview",
    data,
    method: "post"
  });
};
